import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboMaterialComponent} from './combo-material.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboMaterialComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboMaterialComponent]
})
export class ComboMaterialModule {
}
